const initialState = {
    bc_filter_tree: [],
    no_scroll: false,
    user_logged_in: false,
    mobile_big: false,
    mobile_medium: false,
    mobile_small: false,
    mobile5s: false,
    multipass: {},
    similar_products: [],
    total_similar_products: 0,
    query_string_similar_products: null,
    featured_magazines: [],
    curated_collections: {},
    labeled_collections: {},
    vault_custom_collection: {},
    home_details: [],
    social_error: false,
    vip_collections: [],
    vip_products: {},
    show_vip_add_to_list_modal: false,
    show_vip_add_collection_modal: false,
    get_shopify_vip_favorites_in_progress: false,
    default_collection: null,
    show_vip_export_modal: false,
    show_vip_soldout_modal: false,
    show_vip_clear_cart_modal: false,
    show_vip_delete_modal: false,
    product_id: null,
    isFetchingData: false,
    error_message: null,
    show_logout_modal: false,
    is_trade_in_page: false,
    selectedCountry: '',
    availableCountries: [],
    isInternational: false,
    is_first_step: true,
    isUsdInternational: false,
    show_email_confirmation: false,
    show_email_validation: false,
    show_email_validation_success: false,
    email_validation_error_message: '',
    is_trade_in: false,
    vipModalFavCount: null,
    isBoostDown: false,
    stickyFooterElement: false,
    auth: {
        login_type: null,
        modal_opened: false,
        signup_msg: "",
        dismiss_able: true,
        success_signup: false,
        suppress_newsletter_modal: false,
    },
}

export default function appReducer(state=initialState, action) {
    switch (action.type) {
        case 'SET_BC_FILTER_TREE':
            return {
                ...state,
                bc_filter_tree: action.payload,
            }
        case 'NO_SCROLL':
            return {
                ...state,
                no_scroll: action.no_scroll
            };
        case 'MOBILE_BREAKPOINTS':
            return {
                ...state,
                ...action
            };
        case 'MOBILE_MEDIUM':
            return {
                ...state,
                mobile_medium: action.mobile_medium
            };
        case 'INIT':
            window.reactInitialData = action.init;
            return {
                ...state,
                init: action.init
            };
        case 'FEATURED_MAGAZINES':
            return {
                ...state,
                featured_magazines: action.featured_magazines
            }
        case 'SET_PROMO_BANNERS':
            return {
                ...state,
                promo_banners: action.promo_banners
            }
        case 'SET_PROMO_MESSAGING':
            return {
                ...state,
                promo_messages: action.promo_messages
            }
        case 'HOME_DATA_DETAILS':
            return {
                ...state,
                home_details: action.home_details
            };
        case 'SET_MULTIPASS':
            return {
                ...state,
                multipass: action.multipass
            };
        case 'OPEN_LOGIN_MODAL':
            return {
                ...state,
                auth: {...state.auth, login_type: action.login_type, modal_opened: action.modal_opened, signup_msg: action.signup_msg, dismiss_able: action.dismiss_able},
            };
        case 'OPEN_FOOTER_SIGNUP_MODAL':
            return {
                ...state,
                footer_signup_show_popup: action.footer_signup_show_popup
            };
        case 'OPEN_LOGOUT_MODAL':
            return {
                ...state,
                show_logout_modal: true,
                logout_modal_settings: action.logout_modal_settings
            }
        case 'CLOSE_LOGIN_MODAL':
            return {
                ...state,
                auth: {...state.auth, modal_opened: action.modal_opened},
                footer_signup_show_popup: false,
                is_first_step: true
            };
        case 'DISMISS_LOGOUT_MODAL':
            return {
                ...state,
                show_logout_modal: false
            }
        case 'USER_IS_LOGGED_IN':
            return {
                ...state,
                user_logged_in: true
            };
        case 'USER_IS_LOGGED_OUT':
            return {
                ...state,
                user_logged_in: action.user_logged_in
            };
        case 'SHOW_MODAL_SPINNER':
            return {
                ...state,
                isModalFetching: true
            }
        case 'HIDE_MODAL_SPINNER':
            return {
                ...state,
                isModalFetching: false
            }
        case 'HIDE_MODAL_SPINNER_WITH_TYPE':
            return {
                ...state,
                isModalFetching: false,
                was_call_successful: action.was_call_successful
            }
        case 'SHOW_SMALL_SPINNER':
            return {
                ...state,
                isFetchingData: true
            }
        case 'HIDE_SMALL_SPINNER':
            return {
                ...state,
                isFetchingData: false
            }
        case 'SIGNUP_SUCCESS':
            return {
                ...state,
                auth: {...state.auth, modal_opened: action.modal_opened, success_signup: action.success_signup},
            }
        case 'NEWSLETTER_SUCCESS':
            return {
                ...state,
                auth: {...state.auth, modal_opened: action.modal_opened, success_signup: action.success_signup, suppress_newsletter_modal: action.suppress_newsletter_modal},
            }
        case 'NEWSLETTER_SUPPRESS':
            return {
                ...state,
                auth: {...state.auth, suppress_newsletter_modal: action.payload},
            }
        case 'SET_SEARCH_PRODUCTS':
            return {
                ...state,
                similar_products: action.similar_products,
                total_similar_products: action.total_similar_products,
                query_string_similar_products: action.query_string_similar_products,
                show_carousel: action.show_carousel
            }
        case 'SET_CURATED_COLLECTIONS':
            return {
                ...state,
                curated_collections: action.curated_collections
            }
        case 'SET_LABELED_COLLECTIONS':
            return {
                ...state,
                labeled_collections: action.labeled_collections
            }
        case 'SET_STYLE_ASSEMBLY_COLLECTIONS':
            return {
                ...state,
                style_assembly_collections: action.style_assembly_collections
            }
        case 'GET_FOR_YOU_PRODUCTS_HOMEPAGE':
            return {
                ...state,
                for_you_products_homepage: action.for_you_products_homepage
            }
        case 'GET_PRODUCTS_FROM_BC_INIT':
            return {
                ...state,
                products_from_bc_init: action.products_from_bc_init
            }
        case 'SET_NEW_ARRIVALS_COLLECTION':
            return {
                ...state,
                new_arrivals_collection: action.payload
            }
        case 'SET_TRENDING_COLLECTION':
            return {
                ...state,
                trending_collection: action.trending_collection
            }
        case 'SET_CUSTOM_COLLECTION_SLIDE':
            return {
                ...state,
                vault_custom_collection: action.vault_custom_collection
            }
        case 'GET_VAULT_ITEMS':
            return {
                ...state,
                vault_articles: action.vault_articles
            }
        case 'SOCIAL_ERROR':
            return {
                ...state,
                social_error: action.social_error
            }
        case 'SET_VIP_COLLECTIONS':
            return {
                ...state,
                vip_collections: action.vip_collections,
                default_collection: action.default_collection
            }
        case 'SET_VIP_PRODUCTS':
            return {
                ...state,
                vip_products: action.vip_products,
                get_shopify_vip_favorites_in_progress: false
            }
        case 'SHOW_VIP_ADD_TO_LIST_MODAL':
            return {
                ...state,
                show_vip_add_to_list_modal: true,
                product_id: action.product_id,
                vipModalFavCount: action.vipModalFavCount,
            }
        case 'HIDE_VIP_COLLECTIONS_MODAL':
            return {
                ...state,
                show_vip_add_to_list_modal: false,
                vipModalFavCount: null,
            }
        case 'TOGGLE_VIP_ADD_COLLECTION_MODAL':
            return {
                ...state,
                show_vip_add_collection_modal: action.payload
            }
        case 'VIP_EXPORT_MODAL':
            return {
                ...state,
                show_vip_export_modal: action.show_vip_export_modal
            }
        case 'VIP_SOLDOUT_MODAL':
            return {
                ...state,
                show_vip_soldout_modal: action.show_vip_soldout_modal
            }
        case 'VIP_CLEAR_CART_MODAL':
            return {
                ...state,
                show_vip_clear_cart_modal: action.show_vip_clear_cart_modal
            }
        case 'VIP_DELETE_MODAL':
            return {
                ...state,
                show_vip_delete_modal: action.show_vip_delete_modal
            }
        case 'VIP_ERROR_MESSAGE':
            return {
                ...state,
                error_message: action.error_message
            }
        case 'TRADE_IN_ACTIVE':
            return {
                ...state,
                is_trade_in_page: action.for_trade_in
            }
        case 'SIGNUP_STEP1':
            return {
                ...state,
                is_first_step: action.is_first_step,
                email_subscribed: action.email_subscribed,
                sms_subscribed: action.sms_subscribed
            }
        case 'SET_SELECTED_COUNTRY':
            return {
                ...state,
                selectedCountry: action.payload
            }
        case 'SET_AVAILABLE_COUNTRIES':
            return {
                ...state, availableCountries: action.payload
            }
        case 'SET_INTERNATIONAL_STATUS':
            return {
                ...state,
                isInternational: action.payload.isInternational,
                isUsdInternational: action.payload.isUsdInternational,
            }
        case 'TOGGLE_EMAIL_CONFIRMATION':
            return {
                ...state,
                show_email_confirmation: action.toggle,
                show_email_validation: false,
                show_email_validation_success: false,
                email_validation_error_message: ''
            }
        case 'SHOW_EMAIL_VALIDATION':
            return {
                ...state,
                show_email_confirmation: false,
                show_email_validation: action.show_email_validation,
                show_email_validation_success: action.show_email_validation_success,
                email_validation_error_message: action.email_validation_error_message
            }
        case 'SET_BOOST_STATUS':
            return {
                ...state,
                isBoostDown: action.payload
            }
        case 'SET_STICKY_FOOTER_ELEMENT':
            return {
                ...state,
                stickyFooterElement: action.payload
            }
        default:
            return state;
    }
};